"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function CarsBarFound(_a) {
    var _b = _a.title, title = _b === void 0 ? 'Найдено:' : _b, total = _a.total, loading = _a.loading;
    return (react_1.default.createElement("div", { className: "azgazui__cars-found" },
        title,
        react_1.default.createElement("span", { "data-testid": "count" }, !loading && total)));
}
exports.default = CarsBarFound;
CarsBarFound.displayName = 'CarsBarFound';
CarsBarFound.propTypes = {
    total: prop_types_1.default.number.isRequired,
    loading: prop_types_1.default.bool.isRequired,
    // eslint-disable-next-line react/require-default-props
    title: prop_types_1.default.string,
};
